import { Location } from '@eagle/data-function-types';
import { FC, ReactNode, type JSX } from 'react';
import { useSmallScreen } from '../../../hooks';
import { LayoutDesktop } from './layout-desktop';
import { LayoutMobile } from './layout-mobile';

interface PopupViewProps {
  children: ReactNode;
  handleCloseButtonClick: () => void;
  initialSnapPoint?: 'peek' | 'full';
  isPopupOpen: boolean;
  locationData?: Location;
  pane?: string;
  width?: number;
}

export const PopupView: FC<PopupViewProps> = ({
  children,
  handleCloseButtonClick,
  initialSnapPoint = 'peek',
  isPopupOpen,
  locationData,
  pane,
  width,
}): JSX.Element => {
  const smallScreen = useSmallScreen();

  if (!locationData) return <></>;

  if (smallScreen) {
    return (
      <LayoutMobile
        handleCloseButtonClick={handleCloseButtonClick}
        initialSnapPoint={initialSnapPoint}
        isPopupOpen={isPopupOpen}
      >
        {children}
      </LayoutMobile>
    );
  }

  if (!isPopupOpen) return <></>;

  return (
    <LayoutDesktop
      locationData={locationData}
      pane={pane}
      width={width}
    >
      {children}
    </LayoutDesktop>
  );
};
